import { GET_ELECTRIC_COMPANIES_CORE} from './../constants';
import { handleActions } from "redux-actions"

export const electricCompaniesCore  = handleActions(
  { 
    [ GET_ELECTRIC_COMPANIES_CORE ]: (state, action) => {
      // console.log('reduce GET_ELECTRIC_COMPANIES_CORE', action)
      const {error} = action.payload
      if (error) {
        return state
      } else {
        return action.payload.data
      }
    },
  }, []
)